var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacehorstnegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 556,
    height: 600,
    viewBox: "0 0 556 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "face_horst_negative_svg__a",
    d: "M22.577 57.072s37.276 4.665 48.046 41.597C81.392 135.6 102.93.823 46.392.823c-56.539 0-23.815 56.249-23.815 56.249z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_horst_negative_svg__c",
    d: "M40.031 78.224c31.458 0 39.031-17.496 39.031-39.078C79.062 17.564 61.587.068 40.031.068 18.475.068-2.754 1.105 1 39.146c3.754 38.041 7.573 39.078 39.031 39.078z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_horst_negative_svg__e",
    d: "M40.031 78.414c31.458 0 39.031-17.496 39.031-39.078C79.062 17.754 61.587.258 40.031.258 18.475.258-2.754 1.295 1 39.336c3.754 38.042 7.573 39.078 39.031 39.078z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_horst_negative_svg__g",
    d: "M0 37.245C0 16.675 16.672 0 37.248 0c20.571 0 37.248 16.668 37.248 37.245v5.253c0 20.57-16.672 37.245-37.248 37.245C16.676 79.743 0 63.075 0 42.498v-5.253z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_horst_negative_svg__i",
    d: "M1.814 117.416C3.574 52.57 57.594 0 122.445 0h-6.115c64.863 0 117.868 52.578 118.39 117.443l.444 55.335c.521 64.862-51.612 115.809-115.776 113.814l-4.869.144C49.684 288.661-1.449 237.664.311 172.804l1.503-55.388z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_horst_negative_svg__k",
    d: "M52.156 269.724l.158-4.446c1.607-45.397 39.74-82.199 85.147-82.199h40.71c45.418 0 84.73 36.739 87.621 82.077 0 0 .364 1.152.364 7.935-10.14 41.135-55.181 74.111-100.612 73.655l-3.58-.036-19.805-.174c-39.72-8.988-82.457-51.555-90.003-76.812z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#79BEAA",
    stroke: "#363A50",
    strokeWidth: 9,
    d: "M337.248 322.527c10.152 0 18.103 3.823 24.257 10.086 6.711 6.83 11.245 16.722 13.97 27.8 4.37 17.767 4.141 38.548 1.887 53.28-1.545 10.091-4.284 17.367-6.811 20.011-1.461 1.529-3.016 2.157-4.453 2.284-1.623.143-3.344-.274-5.006-1.818-1.32-1.227-2.832-3.649-4.043-7.828-9.986-34.477-49.19-40.776-49.19-40.776s-.75-.12-2.092-.251a45.96 45.96 0 01-1.2-2.176c-.784-1.568-12.78-27.124-3.738-44.195 2.688-5.074 7.087-9.522 14.04-12.528 5.558-2.402 12.855-3.889 22.38-3.889z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 265 327.267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_horst_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_horst_negative_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 9,
    d: "M46.392-3.677c10.187 0 18.165 3.813 24.34 10.056 6.743 6.818 11.298 16.69 14.036 27.746 4.391 17.733 4.16 38.474 1.895 53.178-1.552 10.076-4.305 17.338-6.845 19.979-1.461 1.518-3.014 2.144-4.452 2.27-1.623.143-3.34-.274-5-1.806-1.328-1.225-2.846-3.643-4.063-7.818-9.928-34.045-44.285-38.39-44.285-38.39s-.755-.096-2.102-.16c-.801-1.282-1.228-2.043-1.228-2.043S3.25 31.826 10.946 13.652C13.218 8.285 17.3 3.584 24.127.404c5.395-2.513 12.634-4.08 22.265-4.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79BEAA",
    stroke: "#363A50",
    strokeWidth: 9,
    d: "M46.392-3.677c10.187 0 18.165 3.813 24.34 10.056 6.743 6.818 11.298 16.69 14.036 27.746 4.391 17.733 4.16 38.474 1.895 53.178-1.552 10.076-4.305 17.338-6.845 19.979-1.461 1.518-3.014 2.144-4.452 2.27-1.623.143-3.34-.274-5-1.806-1.328-1.225-2.846-3.643-4.063-7.818-9.928-34.045-44.285-38.39-44.285-38.39s-.755-.096-2.102-.16c-.801-1.282-1.228-2.043-1.228-2.043S3.25 31.826 10.946 13.652C13.218 8.285 17.3 3.584 24.127.404c5.395-2.513 12.634-4.08 22.265-4.08z",
    mask: "url(#face_horst_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M52.02 6.064c18.167 21.81 18.788 44.39 1.864 67.74C36.961 97.152 19.13 94.883.391 67L2.937 7.006l49.084-.942z",
    mask: "url(#face_horst_negative_svg__b)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#886653",
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M42.407 80.358c5.198-5.279 12.564-8.458 20.907-8.187h0l197.464 6.418c8.18.266 15.516 3.819 20.76 9.357 5.244 5.538 8.392 13.057 8.212 21.242h0l-2.736 124.847H40.886l-6.344-132.647c-.398-8.339 2.668-15.752 7.865-21.03z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 173)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_horst_negative_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_horst_negative_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M36.049 6.36l1.494.003.996.003 1.492.002c9.038 0 17.22 3.668 23.142 9.598 5.925 5.932 9.589 14.128 9.589 23.18 0 9.869-1.491 18.96-7.567 25.044-5.064 5.07-13.167 7.734-25.164 7.734-3.209 0-6.11.046-8.73.052h-.969c-7.647-.017-12.784-.499-16.084-3.802-4.505-4.51-5.387-13.515-6.978-29.647-1.31-13.265.406-21.495 5.068-26.163 5.43-5.436 13.941-5.97 22.717-6.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M36.049 6.36l1.494.003.996.003 1.492.002c9.038 0 17.22 3.668 23.142 9.598 5.925 5.932 9.589 14.128 9.589 23.18 0 9.869-1.491 18.96-7.567 25.044-5.064 5.07-13.167 7.734-25.164 7.734-3.209 0-6.11.046-8.73.052h-.969c-7.647-.017-12.784-.499-16.084-3.802-4.505-4.51-5.387-13.515-6.978-29.647-1.31-13.265.406-21.495 5.068-26.163 5.43-5.436 13.941-5.97 22.717-6.001z",
    mask: "url(#face_horst_negative_svg__d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 41.068,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1,
    mask: "url(#face_horst_negative_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M23.181 32.843c0 6.266 5.074 11.345 11.332 11.345h0c6.258 0 11.331-5.08 11.331-11.345",
    mask: "url(#face_horst_negative_svg__d)",
    transform: "scale(1 -1) rotate(-59 -33.563 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 324 172.81)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_horst_negative_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_horst_negative_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M40.031 6.558c9.038 0 17.22 3.669 23.142 9.598 5.925 5.933 9.589 14.128 9.589 23.18 0 9.87-1.491 18.96-7.567 25.044-5.064 5.07-13.167 7.734-25.164 7.734-13.235 0-21.246.792-25.783-3.75-4.505-4.51-5.387-13.514-6.978-29.646-1.286-13.033.348-21.197 4.825-25.914C17.242 7.382 25.368 6.7 33.804 6.59l.956-.01c.797-.008 1.597-.01 2.396-.014l.959-.004 1.28-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M40.031 6.558c9.038 0 17.22 3.669 23.142 9.598 5.925 5.933 9.589 14.128 9.589 23.18 0 9.87-1.491 18.96-7.567 25.044-5.064 5.07-13.167 7.734-25.164 7.734-13.235 0-21.246.792-25.783-3.75-4.505-4.51-5.387-13.514-6.978-29.646-1.286-13.033.348-21.197 4.825-25.914C17.242 7.382 25.368 6.7 33.804 6.59l.956-.01c.797-.008 1.597-.01 2.396-.014l.959-.004 1.28-.003z",
    mask: "url(#face_horst_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 41.258,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1,
    mask: "url(#face_horst_negative_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M301.186 204.724c-5.371-3.227-12.338-1.494-15.561 3.87h0c-3.223 5.364-1.483 12.33 3.888 15.556"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M298 232c3.715 0 7.091 1.757 9.598 4.623 2.71 3.1 4.402 7.499 4.402 12.377 0 9.389-6.268 17-14 17s-14-7.611-14-17c0-1.852.244-3.635.695-5.305"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.575 301.547)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_horst_negative_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_horst_negative_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 9.9,
    d: "M37.227-4.95c11.662-.006 22.22 4.717 29.86 12.358 7.636 7.634 12.359 18.182 12.359 29.837h0v5.253c0 11.527-4.621 21.973-12.112 29.589-7.508 7.632-17.899 12.42-29.41 12.601h0l-.655.005c-11.662.006-22.22-4.717-29.861-12.357C-.227 64.7-4.95 54.153-4.95 42.498h0v-5.253c0-11.526 4.62-21.973 12.112-29.588C14.67.024 25.06-4.763 36.572-4.945h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 9.9,
    d: "M37.227-4.95c11.662-.006 22.22 4.717 29.86 12.358 7.636 7.634 12.359 18.182 12.359 29.837h0v5.253c0 11.527-4.621 21.973-12.112 29.589-7.508 7.632-17.899 12.42-29.41 12.601h0l-.655.005c-11.662.006-22.22-4.717-29.861-12.357C-.227 64.7-4.95 54.153-4.95 42.498h0v-5.253c0-11.526 4.62-21.973 12.112-29.588C14.67.024 25.06-4.763 36.572-4.945h0z",
    mask: "url(#face_horst_negative_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M55.211 30.46S44.413 64.666 72.308 82.668c27.895 18.003-5.399 17.103-5.399 17.103L30.016 69.166l-.9-33.305 26.095-5.4z",
    mask: "url(#face_horst_negative_svg__h)",
    transform: "matrix(-1 0 0 1 112.561 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.592 56.19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_horst_negative_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_horst_negative_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 9.9,
    d: "M119.387-4.91l.963.025c32.924 1.063 62.67 15.12 84.226 37.217 21.48 22.018 34.827 52.014 35.093 85.07h0l.445 55.336c.268 33.444-12.89 63.334-34.33 84.774-21.542 21.543-51.455 34.565-84.568 34.073h0l-1.812-.041-4.738.14c-33.865 1.005-64.138-11.835-85.723-33.368-21.583-21.53-34.5-51.771-33.58-85.646h0l1.503-55.388c.896-33.022 14.8-62.991 36.686-84.99C55.516 10.217 85.51-3.822 118.425-4.884h0l.962-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FABAAA",
    stroke: "#363A50",
    strokeWidth: 9.9,
    d: "M119.387-4.91l.963.025c32.924 1.063 62.67 15.12 84.226 37.217 21.48 22.018 34.827 52.014 35.093 85.07h0l.445 55.336c.268 33.444-12.89 63.334-34.33 84.774-21.542 21.543-51.455 34.565-84.568 34.073h0l-1.812-.041-4.738.14c-33.865 1.005-64.138-11.835-85.723-33.368-21.583-21.53-34.5-51.771-33.58-85.646h0l1.503-55.388c.896-33.022 14.8-62.991 36.686-84.99C55.516 10.217 85.51-3.822 118.425-4.884h0l.962-.025z",
    mask: "url(#face_horst_negative_svg__j)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_horst_negative_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M94.238 184.712c0 12.531 10.147 22.69 22.663 22.69h0c12.517 0 22.663-10.159 22.663-22.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M94.899 183.006s1-18 18-18 3-28 3-28l25 44-13 24h-19l-11-13-3-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M42.578 11.756S-80.09 269.328 175.543 301.733l-208.685 16.202-17.997-133.22-3.6-109.816 97.317-63.143z",
    mask: "url(#face_horst_negative_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M151 34.292s69 11.148 86 59.074l-10-61.074-49-18-27 20z",
    mask: "url(#face_horst_negative_svg__j)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "109.956 248.292 129.956 248.292 119.956 258.217",
    mask: "url(#face_horst_negative_svg__j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 155.81)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M158.23 15.32c-9.312-8.386-26.291-4.71-37.924 8.208M6.203 14.99c9.458-8.222 26.37-4.251 37.775 8.869"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M142.88 43.425c-11.839.695-23.355-6.212-23.355-6.212s7.677-8.033 19.515-8.727c11.839-.695 22.295 2.087 23.355 6.212 1.06 4.126-7.677 8.033-19.515 8.727zM19.819 43.389C8.039 42.497-.408 38.447.953 34.342c1.36-4.106 12.014-6.711 23.794-5.82 11.78.892 18.866 9.048 18.866 9.048S31.6 44.28 19.82 43.389z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.01,
    cy: 36.427,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M38.776 138.332c0-9.358 24.087-15.589 45.643-15.589 21.557 0 30.89-2.857 30.89 6.501"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.67,
    cy: 35.527,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.03,
    d: "M3.319 69.43s13 14 36 2M159.319 69.43s-13 14-36 2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "face_horst_negative_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_horst_negative_svg__k"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_horst_negative_svg__l)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9177.068 -2128.269)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9587.98 -2496.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9201.808 -2884.494)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9615.72 -3080.667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9226.548 -3640.72)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9640.46 -3836.892)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9251.287 -4396.945)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9703.127 -4593.78)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9275.868 -5162.303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9765.795 -5350.667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9270.803 -5984.451)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 6.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 2.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 13.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 7683.96 -2268.538)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 10.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 6.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 2.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 11.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8072.524 -2275.32)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 7683.352 -2835.372)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8097.264 -3031.545)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 7708.092 -3591.598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8122.004 -3787.77)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 7732.832 -4347.823)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8184.671 -4544.658)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 7756.912 -5141.826)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8247.34 -5301.545)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 7615.992 -2256.139)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.297,
    cy: 13.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.891,
    cy: 9.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.891,
    cy: 19.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.486,
    cy: 15.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.08,
    cy: 20.579,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.499,
    cy: 8.551,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.624,
    cy: 2.421,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8160.431 -5920.129)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.297,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.891,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.891,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.486,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.905,
    cy: 8.307,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8919.332 -5887.48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8414.542 -2217.066)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.297,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.297,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.891,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.486,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.486,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8831.092 -2262.126)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8441.92 -2822.179)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8855.832 -3018.352)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8466.66 -3578.404)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8880.571 -3774.577)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8491.4 -4334.63)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8943.239 -4531.464)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8515.48 -5128.633)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 9005.907 -5288.352)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 8539.56 -5922.636)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 514.664 -55.389)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 528.115 -70.254)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 502.998 -86.382)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 516.45 -101.247)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 491.332 -117.375)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 504.783 -132.24)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 480.326 -146.852)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.297,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.891,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.891,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.486,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.08,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.08,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 494.64 -163.896)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 467.341 -180.878)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 484.497 -195.551)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-47 455.016 -213.388)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 355.897 307.605)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 6.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 2.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 12.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 8.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 13.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 370.498 292.24)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 348.83 274.612)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 2.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 8.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 4.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 9.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 358.832 261.247)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 335.365 245.769)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.978,
    cy: 4.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.572,
    cy: 10.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.167,
    cy: 6.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.761,
    cy: 2.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.761,
    cy: 11.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 347.167 230.254)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 322.709 215.642)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.297,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.891,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.891,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.486,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.08,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.08,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 337.023 198.598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 309.724 181.616)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 326.88 166.943)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-47 297.399 149.106)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.978,
    cy: 5.958,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 1.986,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.572,
    cy: 11.255,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.167,
    cy: 7.282,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 3.31,
    rx: 1.978,
    ry: 1.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.761,
    cy: 12.579,
    rx: 1.978,
    ry: 1.986
  })))))), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.954,
    d: "M321.261 289.975c.567.476-.13 2.24-1.557 3.939h0c-1.426 1.7-3.042 2.692-3.608 2.217"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacehorstnegative);
export default __webpack_public_path__ + "static/media/face.horst.negative.855b0f3d.svg";
export { ForwardRef as ReactComponent };